import { styled } from '@fluentui/react';
import { connect } from 'react-redux';
import { getString } from '../../../../web/utils/stringLoader';
import { Environment, SourceApps } from '../../../models/constants/constants';
import { IAppState } from '../../../models/reduxState';
import { getUpsellAgentAssistSubscriptionLink } from '../../../utilities';
import { resetUITabViewStack } from '../../app/appActions';
import { appVerSelector, environmentSelector, getCorrelationId, isAmcSelector, isSmbHubSelector, omnichannelThemeNameSelector, sourceAppSelector } from '../../app/selectors/contactUsSelector';
import { RequestConfirmation } from '../presentationalComponents/RequestConfirmation';
import { navigateBack, updateRaveChatWindowRequestCorrelationId } from '../reduxUpdater/actions/modalitySectionActions';
import { resetSearchSession } from '../reduxUpdater/actions/selfHelpAlchemyActions';
import { getContactUsStyles } from '../styles/contactUsStyles';

const mapStateToProps = (state: IAppState, _ownProps: any) => {
  return {
    results: state.ContactState.SelfHelpAlchemyState.alchemyResults,
    isCreatingRequest: state.ContactState.ModalitySectionState.isCreatingRequest,
    createdRequest: state.ContactState.ModalitySectionState.createdRequest,
    isOrgId: state.ContactState.ModalitySectionState.isOrgId,
    autoOpenRaveChatRequestCorrelationId: state.ContactState.ModalitySectionState.autoOpenRaveChatRequestCorrelationId,
    showModalitiesStickyFooter: state.ContactState.SelfHelpAlchemyState.showModalitiesStickyFooter,
    isModalityThrottled: state.ContactState.ModalitySectionState.isModalityThrottled,
    alchemyThemeRoutingEnabled: state.ContactState.ModalitySectionState.alchemyThemeRoutingEnabled,
    isOutlookDotCom: state.ContactState.SharedState.isOutlookDotCom,
    upsellAgentAssistSubscriptionLink: getUpsellAgentAssistSubscriptionLink(state.ContactState.ModalitySectionState.modalityResponse),
    omnichannelThemeName: omnichannelThemeNameSelector(state),
    isClientApp: state.GlobalState.environment === Environment.nonAgavePane,
    openInAppOmnichannelChatInBrowser: state.ContactState.ModalitySectionState.openInAppOmnichannelChatInBrowser,
    market: state.GlobalState.market,
    isAmc: isAmcSelector(state),
    environment: environmentSelector(state),
    sourceApp: sourceAppSelector(state),
    appVer: appVerSelector(state),
    isSmbHub: isSmbHubSelector(state),
    headerTitle: state.ContactState.ModalitySectionState.createdRequest ? getString('requestConfirmation_serviceRequestPendingTitle') : isAmcSelector(state) ? getString('amcStrings_serviceRequestCreatedTitle') : getString('requestConfirmation_serviceRequestCreatedTitle'),
    alchemyThemeRoutingShowWaitTime: state.ContactState.ModalitySectionState.alchemyThemeRoutingShowWaitTime,
    correlationId: getCorrelationId(state)
  };
};

const mapDispatchToProps = {
  updateRaveChatWindowRequestCorrelationId,
  resetSearchSession,
  resetUITabViewStack,
  navigateBack,
};

export const RequestConfirmationContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(styled(RequestConfirmation, getContactUsStyles));
